import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const waveAnimation = keyframes `
  0%{
    background-position: -200px 0
  }
  50% {
    background-position: 0 0
  }
  100%{
    background-position: 200px 0
  }
`;

const Wave = styled.div`
  animation-duration: 1.6s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${waveAnimation};
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 30%, #d6d6d6 58%, #eeeeee 87%);
  height: 350px;
  position: relative;
  @media (max-width: 1200px) {
    margin-right: -12px;
  }
  @media (max-width: 700px) {
    height: 300px;
    animation-duration: 3s;
  }
  ${props => props.noHeader && `
    height: 280px;
    @media(max-width: 700px) {
      height: 240px;
    }
  `}
`;

const Box = styled.div`
  position: absolute;
  background-color: ${props => props.theme.white};
  &.h-1 {
    top: 200px;
    width: 100%;
    height: 16px;
    @media (max-width: 600px) {
      top: 160px;
    }
  }
  &.h-2 {
    top: 226px;
    width: 100%;
    height: 10px;
    @media (max-width: 600px) {
      top: 186px;
    }
  }
  &.h-3 {
    top: 243px;
    width: 100%;
    height: 6px;
    @media (max-width: 600px) {
      top: 203px;
    }
  }
  &.h-4 {
    top: 256px;
    width: 100%;
    height: 40px;
    @media (max-width: 600px) {
      top: 216px;
    }
  }
  &.n-1 {
    height: 10px;
    top: 216px;
    width: 5.5%;
    left: 20%;
    @media (max-width: 600px) {
      width: 17%;
      left: 63%;  
      top: 176px;
    }
  }
  &.n-2 {
    height: 10px;
    top: 216px;
    width: 5.5%;
    left: 45%;
  }
  &.n-3 {
    height: 10px;
    top: 216px;
    width: 5.5%;
    left: 70%;
  }
  &.n-4 {
    height: 10px;
    top: 216px;
    width: 5.5%;
    left: 95%;
  }
  &.p-1 {
    height: 8px;
    top: 248px;
    width: 13.5%;
    left: 12%;
    @media (max-width: 600px) {
      width: 21%;
      left: 59%;
      top: 208px;
    }
  }
  &.p-2 {
    height: 8px;
    top: 248px;
    width: 13.5%;
    left: 37%;
  }
  &.p-3 {
    height: 8px;
    top: 248px;
    width: 13.5%;
    left: 62%;
  }
  &.p-4 {
    height: 8px;
    top: 248px;
    width: 13.5%;
    left: 87%;
  }
  &.divider {
    width: 10px;
    height: 300px; 
    top: 0;
  }
  &.divider-1 {
    left: 25%;
    @media (max-width: 1200px) {
      left: 38%;
    }
    @media (max-width: 600px) {
      left: 80%;
      height: 260px;
    }
  }
  &.divider-2 {
    left: 50%;
    @media (max-width: 1200px) {
      left: 77%;
    }
    @media (max-width: 600px) {
      display: none;
    }
  }
  &.divider-3 {
    left: 75%;
    @media (max-width: 1200px) {
      display: none;
      left: 96%;
    }
  }
  &.mobile-hide {
    @media (max-width: 700px) {
      display: none !important;
    }
  }
  &.header-top {
    width: 100%;
    height: 20px;
    top: 0;
    left: 0;
  }
  &.header-right {
    width: 60%;
    height: 20px;
    top: 20px;
    right: 0;
  }
  &.header-bottom {
    width: 100%;
    height: 24px;
    top: 40px;
    left: 0;
    @media (max-width: 700px) {
      top: 36px;
      height: 18px;
    }
  }
`;

const HeaderContainer = styled.div`
  position: relative;
  min-height: 64px;
  @media (max-width: 700px) {
    min-height: 50px;
  }
`;

const BodyContainer = styled.div`
  min-height: 300px;
  position: relative;
  @media (max-width: 600px) {
    min-height: 260px;
  }
`;

const PlaceholderSection = ({ showHeader = true }) => (
  <Wave noHeader={!showHeader}>
    {showHeader && (
      <HeaderContainer>
        <Box className="header-top" />
        <Box className="header-right" />
        <Box className="header-bottom" />
      </HeaderContainer>
    )}
    <BodyContainer>
      <Box className="divider divider-1" />
      <Box className="divider divider-2 mobile-hide" />
      <Box className="divider divider-3 mobile-hide" />
      <Box className="h-1" />
      <Box className="h-2" />
      <Box className="h-3" />
      <Box className="h-4" />
      <Box className="n-1" />
      <Box className="n-2 mobile-hide" />
      <Box className="n-3 mobile-hide" />
      <Box className="n-4 mobile-hide" />
      <Box className="p-1" />
      <Box className="p-2 mobile-hide" />
      <Box className="p-3 mobile-hide" />
      <Box className="p-4 mobile-hide" />
    </BodyContainer>
  </Wave>
);

PlaceholderSection.propTypes = {
  showHeader: PropTypes.bool,
};

export default PlaceholderSection;
